import React from "react";
import SectionView from "../../../Common/Views/SectionView";
import Course from "../../../Common/Models/Course";
import GeneralInfoListItem from "./GeneralInfoListItem";
import CreditIcon from "@material-ui/icons/DonutLarge";
import SchoolIcon from "@material-ui/icons/School";
import DetailListItem from "../../../Common/Views/ListItems/DetailListItem";

interface InformationSectionProps {
    course: Course;
}

const InformationSection = (props: InformationSectionProps) => {
    const {course} = props;

    return (
        <SectionView title={"Information"}>
            {course?.grade &&
               <DetailListItem
                   title={course.grade}
                   icon={<SchoolIcon />}
                   item={course}
                   displayFavorite={false}
                   showDivider={true}
                   />
            }
            <DetailListItem
                title={`${course?.credits} credits`}
                icon={<CreditIcon />}
                item={course}
                showDivider={true}
                displayFavorite={false}
                />
        </SectionView>
    );
};

export default InformationSection;